export default __webpack_public_path__ + "static/media/create-invoice.3a7ba0d0.webp";